const Fonts = {
  body: "Teachers, Helvetica",
  heading: "Teachers, Helvetica",
  mono: "Open Sans, Helvetica",
}

export default Fonts
